import { AlertCircle } from "lucide-react";
import Link from "next/link";

interface ErrorStateProps {
  title: string;
  message: string;
  /** Show "Try again" (reload) alongside the link back to all comparisons. */
  retry: boolean;
}

/**
 * Centered error / not-found state for comparison pages.
 * @param props - heading, body copy, and whether a reload makes sense
 * @returns the state block
 */
export default function ErrorState({ title, message, retry }: ErrorStateProps) {
  return (
    <div className="container-page container-top pb-32">
      <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-20 text-center">
        <span className="flex size-12 items-center justify-center rounded-full bg-landing-secondary">
          <AlertCircle className="size-6 text-landing-secondary" aria-hidden />
        </span>
        <h1 className="text-h4 text-landing-primary">{title}</h1>
        <p className="text-body text-landing-secondary">{message}</p>
        <div className="flex gap-3 pt-2">
          {retry && (
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-xl bg-(--landing-button-primary-bg) px-4 py-2.5 text-tag-md text-white transition-all hover:bg-(--landing-button-primary-hover) active:scale-95"
            >
              Try again
            </button>
          )}
          <Link
            href="/comparisons"
            className="rounded-xl border border-landing-primary bg-white px-4 py-2.5 text-tag-md text-landing-primary transition-colors hover:bg-landing-secondary"
          >
            All comparisons
          </Link>
        </div>
      </div>
    </div>
  );
}
